export enum ContractApplicabilityFilter {
  APPLICABLE = 'applicable',
  INAPPLICABLE = 'inapplicable',
}

export enum ArrivalsStatisticsFilterKeys {
  selectedWarehouses = 'selectedWarehouses',
  isApplicable = 'isApplicable',
  startDate = 'startDate',
  endDate = 'endDate',
  accountType = 'accountType',
}
